<template>
  <div class="fuzzy-search-input-box">
    <el-input v-if="!multiple" :placeholder="placeholder" :size="size"
      @keyup.enter.native="onFuzzySearchInputEnt"
      v-model="innerValue">
      <template #suffix>
        <i class="el-icon-search fuzzy-search-icon" @click="onFuzzySearchInputEnt"></i>
      </template>
    </el-input>
    <!-- 多条件输入框 -->
    <div v-if="multiple" class="fuzzy-search-input-multiple-box">
      <el-input
        type="textarea"
        :placeholder="placeholder"
        v-model="innerValue"
        resize="none"
        :size="size"
        @focus="fuzzySearchInputFocus"
        @blur="fuzzySearchInputBlur"
        @input="fuzzySearchInputInput"
        class="fuzzy-search-input-multiple"
        :style="{height: inputFocus ? `${32 * 6}px` : '32px'}"
        suffix-icon="el-icon-date"
      >
      </el-input>
      <i class="el-icon-search fuzzy-search-icon-multiple" @click="onFuzzySearchInputEnt"></i>
    </div>
  </div>
</template>
<script>
import { ShowErrorMessage } from '@/components/modal/tips/message-tips';

export default {
  name: 'FuzzyInput',
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'small',
    },
    count: {
      type: Number,
      default: 50,
    },
  },
  data() {
    return {
      innerValue: this.value,
      inputFocus: false,
    };
  },
  created() {
    this.innerValue = this.value;
  },
  methods: {
    onFuzzySearchInputEnt() {
      this.$emit('enter');
    },
    fuzzySearchInputFocus() {
      this.inputFocus = true;
      this.innerValue = this.innerValue.replace(/,/g, '\n');
    },
    fuzzySearchInputBlur() {
      this.inputFocus = false;
      if (this.innerValue) {
        let newValue = this.innerValue.replace(/\s*\n\s*/g, ',').trim();
        if (newValue.charAt(newValue.length - 1) === ',') {
          newValue = newValue.substring(0, newValue.length - 1);
        }
        newValue = newValue.split(',').filter((t, i) => i < this.count).join(',').replace(/,+/g, ',');
        this.innerValue = newValue;
      }
    },
    fuzzySearchInputInput() {
      let v = this.innerValue.replace(/\s*\n\s*/g, ',').trim();
      if (v.charAt(v.length - 1) === ',') {
        v = v.substring(0, v.length - 1);
      }
      if (v.split(',').length > this.count) {
        ShowErrorMessage(this.$t('message.validator.count', { count: this.count }));
      }
    },
  },
  watch: {
    value(val) {
      this.innerValue = val;
    },
    innerValue() {
      this.$emit('update:value', this.innerValue);
      this.$emit('input', this.innerValue);
    },
  },
};
</script>
<style lang="scss">
.fuzzy-search-input-box {
  .fuzzy-search-input-multiple-box {
    position: relative;
    .fuzzy-search-input-multiple {
      position: absolute;
      z-index: 9;
      textarea {
        overflow: auto;
      }
      textarea::-webkit-scrollbar {
        width: 1px;
        background-color: transparent;
      }
      textarea::-webkit-scrollbar-thumb {
        -webkit-box-shadow: none;
        background-color: transparent;
      }
      .el-textarea__inner {
        min-height: 32px !important;
        height: 100% !important;
        padding-right: 30px;
      }
    }
    .fuzzy-search-icon-multiple {
      position: absolute;
      right: 8px;
      top: 9px;
      z-index: 10;
      color: #C0C4CC;
    }
  }
}
</style>
